import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flex-basis-30" }
const _hoisted_2 = { class: "_flexcol _flex-basis-70" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_paragraph = _resolveComponent("skeleton-paragraph")
  const _component_circle_icon = _resolveComponent("circle-icon")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, { class: "_flex _gap-3" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_skeleton_image)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_skeleton_paragraph, { lines: 1 }),
        _createVNode(_component_circle_icon, {
          class: "_mt-a _as-fe",
          theme: "disabled",
          size: "large",
          icon: "plus"
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}